<div class="container isg-confirmation-input-dlg">
  <form class="k-form" [formGroup]="formGroup" autocomplete="off">
    <kendo-formfield>
      <label class="isg-confirmation-label" for="content">{{ content() }}</label>
      <input #contentInput
             id="content"
             formControlName="content"
             kendoTextBox
             autocomplete="off"
             />
      @if (formGroup.get('content')?.hasError('required')) {
      <kendo-formerror>Value is required</kendo-formerror>
      }
      @if (formGroup.get('content')?.hasError('notAcceptable')) {
      <kendo-formerror>Value is already in use</kendo-formerror>
      }
      @if (formGroup.get('content')?.hasError('maxlength')) {
      <kendo-formerror>Maximum length is {{ maxLength() }} characters</kendo-formerror>
      }

      @if (formGroup.get('content')?.hasError('slashNotAllowed')) {
      <kendo-formerror>
        Slash characters ( / and \ ) are not allowed
      </kendo-formerror>
      }
    </kendo-formfield>
  </form>
  <kendo-dialog-actions>
    <button kendoButton (click)="onOk()" themeColor="primary" [disabled]="!formGroup.valid">Ok</button>
    <button kendoButton (click)="onCancel($event)">Cancel</button>
  </kendo-dialog-actions>
</div>
